// extracted by mini-css-extract-plugin
module.exports = {"Content":"productVideo_Content__E8SW7"};